import PropTypes from "prop-types";
import React from "react";

class BooleanField extends React.PureComponent {
  static get propTypes() {
    return {
      checkIcon: PropTypes.string,
      title: PropTypes.string,
      uncheckIcon: PropTypes.string,
      value: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      checkIcon: "fa-check",
      title: "",
      uncheckIcon: "fa-times",
      value: false,
    };
  }

  render() {
    const { checkIcon, title, uncheckIcon, value } = this.props;

    if (value) {
      return <i className={`fa ${checkIcon} text-success`} title={title} />;
    }

    if (uncheckIcon) {
      return <i className={`fa ${uncheckIcon} text-danger`} title={title} />;
    }

    return null;
  }
}

export { BooleanField };
